import { render, staticRenderFns } from "./invoices.vue?vue&type=template&id=7c1d95e6&scoped=true&"
import script from "./invoices.vue?vue&type=script&lang=ts&"
export * from "./invoices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1d95e6",
  null
  
)

export default component.exports